import { Assertion } from './assert'

export const SmallerThan = (max: number): Assertion =>
	({
		name: `Smaller Than ${max} Assertion`,
		fn: testValue => {
			switch (typeof testValue) {
				case 'undefined':
				case 'boolean':
				case 'function':
				case 'symbol':
					return false
				case 'object':
					return JSON.stringify(testValue).length < max
				case 'string':
					return testValue.length < max
				case 'bigint':
				case 'number':
					return testValue < max
			}
		}
	}) as Assertion
